<template>
    <div class="grid grid__base" :class="rootClasses">
        <div class="image-slider--container grid--container">
            <div v-if="isInteractive">
                <swiper-slider :items="images">
                    <template slot-scope="props">
                        <figure class="image-slider--image-wrapper">
                            <base-image class="image-slider--image" v-bind="props.image"/>
                        </figure>
                    </template>
                </swiper-slider>
            </div>
            <figure class="image-slider--image-wrapper" v-else>
                <base-image class="image-slider--image" v-bind="images[0].image"/>
            </figure>
        </div>
    </div>
</template>

<script>
    import bemMixin from 'framework/mixins/bem';
    import SwiperSlider from 'framework/components/swiper-slider/swiper-slider';

    export default {
        components: { SwiperSlider },
        mixins: [bemMixin('image-slider')],
        props: {
            /** @type {IImageSliderItem[]} */
            images: {
                type: Array,
                required: true,
            },
        },
        computed: {
            isInteractive() {
                return this.images.length > 1;
            },
            rootClasses() {
                return [this.bemRoot, this.bemFacets, this.bemIf(this.isInteractive, 'is-interactive')];
            },
        },
    };
</script>
